module.exports = __webpack_public_path__ + "static/img/jd5.b3a1836.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd5.jpg
// module id = 7jVG
// module chunks = 1